module.exports = __webpack_public_path__ + "static/media/con_spa_ris_ass_and_saf_pla.deffd08b.png";